module.exports = __webpack_public_path__ + "static/media/HockeyBkgSplash.1c2c3fd0.png";